module.exports = __webpack_public_path__ + "static/media/profile-picture.c3f60ac7.jpg";